@if (show) {
  <div
    class="light-error-box"
    role="alert"
    aria-live="assertive"
    id="error-message-list"
    tabindex="-1"
  >
    <button
      class="light-error-box-close light-btn light-btn-xs light-btn-link"
      (click)="close()"
      aria-label="Close"
    >
      <i class="ico-cancel" aria-hidden="true"></i>
    </button>
    <ul>
      @for (msg of messages; track msg; let i = $index) {
        <li class="validation_error" id="error-{{ i }}">{{ msg | translate }}</li>
      }
    </ul>
  </div>
}
